// extracted by mini-css-extract-plugin
export var dropdownIcon = "_m9-6";
export var imgContainer = "_m9-3";
export var menuIcon = "_m9-5";
export var pillWrapper = "_m9-2";
export var pillsContainer = "_m9-1";
export var subscriptionCard = "_m9-0";
export var subscriptionLogo = "_m9-4";